module.exports = __webpack_public_path__ + "static/img/cont54 (1).d00eb81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont54 (1).jpg
// module id = ev1w
// module chunks = 0